import { render, staticRenderFns } from "./selected-goods-get-coupons.vue?vue&type=template&id=920f5384&"
import script from "./selected-goods-get-coupons.vue?vue&type=script&lang=js&"
export * from "./selected-goods-get-coupons.vue?vue&type=script&lang=js&"
import style0 from "./selected-goods-get-coupons.vue?vue&type=style&index=0&module=true&lang=less&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports